import api from "../services/api";

export const claimTicketAi = async ticketId => {
  const { data: fresh } = await api.get(`/tickets/${ticketId}`);
  const { data } = await api.post(`/tickets/${ticketId}/ai/claim`, {
    expectedVersion: fresh.aiServiceVersion
  });
  return data.ticket;
};
